module.exports = __webpack_public_path__ + "c68b02068c966e173d9c9242ff61d451.svg";